module.exports = "/images/android-chrome-192x192.png?4e2c4ce";


//////////////////
// WEBPACK FOOTER
// ./resources/img/favicon/android-chrome-192x192.png
// module id = 20
// module chunks = 0